import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default, { useMemo } from 'react';
import c from 'classnames';
import Box from '../Box/Box.js';
import { setGap, setGapX, setGapY } from './styles.js';
import { joinChildren, DIRECTION_CLASSNAME, ALIGN_ITEMS_CLASSNAME, JUSTIFY_CONTENT_CLASSNAME } from './utils.js';

var _excluded = ["alignItems", "children", "className", "direction", "divider", "gap", "gapX", "gapY", "justifyContent", "spacing"];
var Stack = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$alignItems = props.alignItems,
    alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
    children = props.children,
    className = props.className,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'row' : _props$direction,
    divider = props.divider,
    gap = props.gap,
    gapX = props.gapX,
    gapY = props.gapY,
    _props$justifyContent = props.justifyContent,
    justifyContent = _props$justifyContent === void 0 ? 'start' : _props$justifyContent,
    spacing = props.spacing,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var directionClassname = DIRECTION_CLASSNAME[direction];
  var alignItemsClassname = ALIGN_ITEMS_CLASSNAME[alignItems];
  var justifyContentClassname = JUSTIFY_CONTENT_CLASSNAME[justifyContent];
  var modifiedChildren = useMemo(function () {
    return divider ? joinChildren(children, divider) : children;
  }, [children, divider]);
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: ref,
    className: c('flex', gap && setGap(gap), gapX && setGapX(gapX), gapY && setGapY(gapY), spacing, directionClassname, alignItemsClassname, justifyContentClassname, className)
  }, rest), modifiedChildren);
});
Stack.displayName = 'Stack';

export { Stack as default };
//# sourceMappingURL=Stack.js.map
